import React, { useState } from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { setLogin } from '../app/loginSlice';
import { getRoles } from '../utils/loginUtil';
import { totalClearUsers, dispatchUsersForRole, dispatchUsersForAllRoles } from '../app/usersSlice';
import { useOktaAuth } from '@okta/okta-react';
import { clearActivities } from '../app/activitiesSlice';
import { clearAchievements } from '../app/achievementsSlice';
import Button from '@msi/cobalt-react/button';

const LoginPage = () => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  const { authState, oktaAuth } = useOktaAuth();
  const callLogin = async () => oktaAuth.signInWithRedirect();

  const setLogout = () => {
    setError('Unknown user.');
    window._loginEmail = '';
    window._loginRights = {};
    dispatch(clearActivities());
    dispatch(clearAchievements());
    dispatch(totalClearUsers());
    dispatch(setLogin({ email: '', rights: {}, roles: [], selectedRole: '', coreId: '' }));
  };

  const handleLogin = async () => {
    if (email.endsWith('@motorolasolutions.com')) {

      const rolesResponse = await getRoles(email);
      const rights = {
        admin: rolesResponse.isAdmin,
        manager: rolesResponse.isManager,
        user: rolesResponse.isUser
      };

      if (!rolesResponse.isAdmin && !rolesResponse.isManager && !rolesResponse.isUser) {
        setLogout();
        return;
      }

      const roles = [];
      if (rolesResponse.isUser) {
        roles.push('User');
      }
      if (rolesResponse.isManager) {
        roles.push('Manager');
      }
      if (rolesResponse.isAdmin) {
        roles.push('Admin');
      }

      window._loginEmail = email;
      window._loginRights = rights;
      const selectedRole = roles[0];
      let coreId = rolesResponse?.userObj?.coreId || '';

      dispatch(setLogin({ email, rights, roles, selectedRole, coreId }));
      dispatchUsersForAllRoles(dispatch, rolesResponse.allUsers, rolesResponse.managedUsers, rolesResponse.userObj);
      dispatchUsersForRole(dispatch, selectedRole, rolesResponse.allUsers, rolesResponse.managedUsers, rolesResponse.userObj);
    } else {
      setLogout();
    }
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    if (error) {
      setError('');
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="90vh"
      sx={{ backgroundColor: (theme) => theme.palette.secondary.main, color: (theme) => theme.palette.text.main }}
    >
      <Box
        width={300}
        p={1}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        border={1}
        borderRadius={2}
        borderColor={ (theme) => theme.palette.outline.main }
        backgroundColor= {(theme) => theme.palette.appLayer.main}
      >
        <Typography variant="h4" mb={0}>
          Login
        </Typography>
        {false && (<>
          <TextField
            label="Email (with CoreId)"
            type="email"
            value={email}
            onChange={handleEmailChange}
            fullWidth
            margin="normal"
            error={!!error}
            helperText={error}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleLogin}
            fullWidth
          >
            Login
          </Button>
        </>)}

        {callLogin &&
          (<Button
            variant="contained"
            color="primary"
            onClick={callLogin}
            fullWidth
            sx={{ marginTop: 2 }}
          >
            MSI Okta Login
          </Button>)
        }
      </Box>
    </Box>
  );
};

export { LoginPage };
